// extracted by mini-css-extract-plugin
export default {"input":"SignInForm_input__Q+OMz","errored":"SignInForm_errored__C61cf","error":"SignInForm_error__oot07","flex":"SignInForm_flex__YNFtY","forgot":"SignInForm_forgot__4oxqQ"};